import { configureStore, combineReducers } from '@reduxjs/toolkit';
import adminReducer from './action';

const reducer = combineReducers({
  admin: adminReducer
});

const store = configureStore({
  reducer
});

export default store;
